/**
 * Copyright (C) 2010-2026 Kazo Vision. (http://www.kazovision.com)
 * All rights reserved.
 */
import api from '@/api';
//coach card Api
export const CoachCardApi = {
    // 获取语言列表
    getLanguageList: () => api.request.post('/coachCard/getLanguageList'),
    //  获取语言
    getLanguage: (params) => api.request.get('/coachCard/getLanguage', { params }),
    // 设置语言
    setLanguage: (params) => api.request.post('/coachCard/setLanguage', params),
    // 导入教练卡excel
    importCoachCardExcel: (params) => api.request.post('/coachCard/importCoachCardExcel', params, { headers: { 'Content-Type': 'multipart/form-data' } }),
    // 导出教练卡
    exportCoachCard: (params) => {
        return api.request.post('/coachCard/exportCoachCard', params, {
            responseType: 'blob'
        });
    },
    // 根据eventphase_type1获取parts配置
    getPartList: (params) => api.request.get('/coachCard/getPartList', { params }),
    // 获取BaseMark选项列表
    getBaseMarkOptions: () => api.request.get('/coachCard/getBaseMarkOptions'),
    // 获取TRE的申报难度列表
    getTREDeclaredDifficultyList: (params) => api.request.get('/coachCard/getTREDeclaredDifficultyList', { params }),
    // 获取ACRO的数据（双人不传参，集体的传参）
    getAcroComponents: (params) => api.request.get('/coachCard/getAcroComponents', { params }),
    // 获取ACRO TEAM的单个code的动作列表
    getAcroComponentListByCode: (params) => api.request.get('/coachCard/getAcroComponentListByCode', { params }),
    // 解析ACRO code并计算分数
    parseAcroCode: (params) => api.request.get('/coachCard/parseAcroCode', { params }),
    // 获取HYBRID分类列表
    getHybridFamilyList: (params) => api.request.get('/coachCard/getHybridFamilyList', { params }),
    // 获取HYBRID分类的详细数据
    getHybridCategories: (params) => api.request.get('/coachCard/getHybridCategories', { params }),
    // 计算HYBRID最终code和分数
    calculateHybridWithRatio: (params) => api.request.get('/coachCard/calculateHybridWithRatio', { params }),
    // 获取Bonus选项列表
    getBonusOptions: () => api.request.get('/coachCard/getBonusOptions'),
    // 获取所有申报难度的详细信息
    getDeclaredDifficultyDetail: (params) => api.request.get('/coachCard/getDeclaredDifficultyDetail', { params }),
    // 根据code获取base_mark、declared_difficulty和bonus的分数
    getScoresByCodes: (params) => api.request.get('/coachCard/getScoresByCodes', { params }),
};
